import { Component, OnInit, AfterContentInit, ContentChildren, QueryList, Input } from '@angular/core';
import { AccordionPanelComponent } from '../accordion-panel/accordion-panel.component';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {

  @Input() allowMultipleOpenPanels: boolean;

  @ContentChildren(AccordionPanelComponent) panelsQuery: QueryList<AccordionPanelComponent>;
  public panels: Array<AccordionPanelComponent>;

  constructor() { }

  ngOnInit() {}

  ngAfterContentInit()
  {
    this.panels = this.panelsQuery.toArray();
  }

  public toggle(panelToToggle: AccordionPanelComponent)
  {
    if (this.allowMultipleOpenPanels)
    {
      panelToToggle.collapsed = !panelToToggle.collapsed;
    }
    else
    {
      this.panels.forEach((panel: AccordionPanelComponent) => {
        if (panelToToggle === panel)
        {
          panel.collapsed = !panel.collapsed
        }
        else
        {
          panel.collapsed = true;
        }
      });
    }
  }

  hasPanel(panel: AccordionPanelComponent) {
    return this.panels.find(x => x == panel) != null;
  }

  collapse(panelToOpen: AccordionPanelComponent) {
    this.panels.forEach((panel: AccordionPanelComponent) => {
      if (panelToOpen === panel)
      {
        panel.collapsed = false;
      }
      else
      {
        panel.collapsed = true;
      }
    });
  }

  closeAll() {
    this.panels.forEach((panel: AccordionPanelComponent) => {
      panel.collapsed = true;
    });
  }
}
